export default __webpack_public_path__ + "static/media/277.39b1310d.gif";